
import { NgModule } from '@angular/core';

import { EventEditProvider } from './event-edit.provider';
import { EventListProvider } from './event-list.provider';

export * from './event-edit.provider';
export * from './event-list.provider';

export {
  EventListProvider,
  EventEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    EventEditProvider,
    EventListProvider
  ]
})
export class EventBackendModule { }
